import { useContext } from 'react';
import { LogoutContext } from '@/providers/logout.provider';
export function useLogout() {
  const context = useContext(LogoutContext);
  if (!context) {
    throw new Error("useLogout must be used within a LogoutProvider");
  }
  return context;
}